module.exports = __webpack_public_path__ + "c883050c2326426817503ed870468a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/leagues/italia.png
// module id = 1049
// module chunks = 0